import React from 'react';
import './Header.scss';

export type HeaderProps = React.HTMLAttributes<HTMLDivElement>;

export const Header: React.FC<HeaderProps> = ({ children, ...props }) => {
    return (
        <div className="header" {...props}>
            {children}
        </div>
    );
};
